export default "__VITE_ASSET__0vJPWXZJ__"